'use strict';
import { html } from 'lit-html';
import { componentLayout } from '../../components/layout/layout.component';
import backimage from '../../assets/images/header-default.jpg';

let templateRedMercado = (contactData) => {
  const { title, body } = contactData;
  return componentLayout.render(
    html`
      <div class="esios-Redmercado">
        <div class="grid-sm-23 grid-xs-24">
          <h1 class="esios-Redmercado__title">${title}</h1>
          ${html([body])}
        </div>
      </div>
    `,
    {
      image: backimage,
      showFooterImage: true,
    }
  );
};

export { templateRedMercado };
